import { isPlatformServer, NgIf } from '@angular/common';
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Inject,
	Input,
	PLATFORM_ID,
} from '@angular/core';
import {
	CallToActionResponse,
	CarouselDirective,
	CarouselComponent,
	IntersectionService,
} from '@woolworthsnz/styleguide';
import { ProductResponse } from '@woolworthsnz/trader-api';
import { GridComponent } from '../grid/grid.component';

@Component({
	selector: 'product-carousel',
	styleUrls: ['./carousel-element.component.scss'],
	template: `
		<ng-container *ngIf="products">
			<cdx-carousel [hero]="hero" [analyticsID]="analyticsID" [name]="name">
				<product-grid
					cdxCarousel
					[name]="name"
					[title]="title"
					[products]="products"
					[isshopper]="isShopper"
					[isloggedin]="isLoggedIn"
				></product-grid>
			</cdx-carousel>
		</ng-container>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [IntersectionService],
	standalone: true,
	imports: [NgIf, CarouselComponent, GridComponent, CarouselDirective],
})
export class CarouselElementComponent implements AfterViewInit {
	@Input() products: (CallToActionResponse | ProductResponse)[];

	@Input() name: string;
	@Input() title: string;
	@Input() analyticsID: string;

	private _hero: CallToActionResponse;
	private _isShopper = false;
	private _isLoggedIn = false;

	@Input() set hero(hero: CallToActionResponse) {
		this._hero = (typeof hero === 'string' ? JSON.parse(hero) : hero) || [];
	}

	get hero(): CallToActionResponse {
		return this._hero;
	}

	@Input() set isshopper(s: boolean) {
		this._isShopper = s;
	}

	get isShopper(): boolean {
		return this._isShopper;
	}

	@Input() set isloggedin(s: boolean) {
		this._isLoggedIn = s;
	}

	get isLoggedIn(): boolean {
		return this._isLoggedIn;
	}

	constructor(
		private cdr: ChangeDetectorRef,
		private el: ElementRef,
		private intersectionService: IntersectionService,
		@Inject(PLATFORM_ID) private platformId: Object
	) {
		if (isPlatformServer(this.platformId)) {
			return;
		}

		this.cdr.detach();
	}

	ngAfterViewInit(): void {
		if (isPlatformServer(this.platformId)) {
			return;
		}

		this.intersectionService.initIntersect({ cb: this.triggerChangeDetection, condition: true, el: this.el });
	}

	triggerChangeDetection = (): void => {
		this.cdr.markForCheck();
		this.cdr.reattach();
	};
}
